function initPDP(root) {
  var configEl = root.querySelector('[data-pdp-config]');
  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch(e) {}

  var dataEl = root.querySelector('[data-product-json]');
  var product;
  try { product = JSON.parse(dataEl.textContent); } catch(e) { return; }

  /* ── State ── */
  var selectedOpts = product.options.map(function(o, i) {
    var firstV = product.variants[0];
    return firstV ? firstV.options[i] : '';
  });
  /* Re-read from active buttons (initial DOM state) */
  root.querySelectorAll('.kb-pdp__swatch.is-active, .kb-pdp__size.is-active').forEach(function(btn) {
    var oi = parseInt(btn.dataset.opt, 10);
    selectedOpts[oi] = btn.dataset.val;
  });

  var currentImg = 0;

  /* ── Helpers ── */
  function findVariant() {
    return product.variants.find(function(v) {
      return v.options.every(function(o, i) { return o === selectedOpts[i]; });
    });
  }

  var moneyFormat = config.moneyFormat || '${{amount}}';
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var n = parseInt(cents, 10) || 0;
    var amt = (n / 100).toFixed(2);
    var amtInt = Math.floor(n / 100).toString();
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amtInt)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amtInt)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amt.replace('.', ' '))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, amtInt);
  }

  /* ── Gallery (scroll-snap carousel) ── */
  var track    = root.querySelector('[data-track]');
  var counter  = root.querySelector('[data-counter]');
  var thumbs   = root.querySelectorAll('.kb-pdp__thumb');
  var slides   = root.querySelectorAll('.kb-pdp__slide');

  function scrollToIdx(idx, smooth) {
    if (!track || idx < 0 || idx >= slides.length) return;
    var x = idx * track.clientWidth;
    if (smooth === false) {
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = x;
      track.style.scrollBehavior = prevBehavior;
    } else {
      track.scrollTo({ left: x, behavior: 'smooth' });
    }
  }

  /* Update counter/thumbs based on current scroll position */
  var scrollRaf;
  var progressBar = root.querySelector('[data-progress-bar]');
  var thumbStrip = root.querySelector('[data-thumbs]');
  function syncProgress() {
    if (!progressBar || !track || slides.length < 2) return;
    var max = track.scrollWidth - track.clientWidth;
    var ratio = max > 0 ? Math.max(0, Math.min(1, track.scrollLeft / max)) : 0;
    progressBar.style.transform = 'translateX(' + (ratio * (slides.length - 1) * 100) + '%)';
  }
  function revealThumb(i) {
    var t = thumbs[i];
    if (!thumbStrip || !t || thumbStrip.scrollWidth <= thumbStrip.clientWidth) return;
    var left = t.offsetLeft - (thumbStrip.clientWidth - t.offsetWidth) / 2;
    thumbStrip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }
  function onTrackScroll() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function() {
      scrollRaf = null;
      if (!track || !track.clientWidth) return;
      syncProgress();
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      idx = Math.max(0, Math.min(slides.length - 1, idx));
      if (idx !== currentImg) {
        currentImg = idx;
        if (counter) counter.textContent = (idx + 1) + ' / ' + product.images.length;
        thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
        revealThumb(idx);
      }
    });
  }
  window.addEventListener('resize', syncProgress);
  if (track) track.addEventListener('scroll', onTrackScroll, { passive: true });

  /* Public: jump to image, used by variant change too */
  function showImg(idx, dir) {
    scrollToIdx(idx, true);
  }

  /* Arrow nav buttons */
  root.querySelectorAll('[data-nav]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var dir = parseInt(this.dataset.nav, 10);
      var next = (currentImg + dir + slides.length) % slides.length;
      scrollToIdx(next, true);
    });
  });

  /* Thumbnails */
  thumbs.forEach(function(t) {
    t.addEventListener('click', function() {
      scrollToIdx(parseInt(this.dataset.thumb, 10), true);
    });
  });

  /* ── Variant selection ── */
  function updateActiveButtons() {
    root.querySelectorAll('.kb-pdp__swatch, .kb-pdp__size').forEach(function(btn) {
      var oi = parseInt(btn.dataset.opt, 10);
      btn.classList.toggle('is-active', btn.dataset.val === selectedOpts[oi]);
    });
    root.querySelectorAll('[data-opt-value]').forEach(function(el) {
      var oi = parseInt(el.dataset.optValue, 10);
      el.textContent = selectedOpts[oi] || '';
    });
  }

  function updatePriceAndATC(instant) {
    var v = findVariant();
    var priceEl   = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl    = root.querySelector('[data-save]');
    var mrpWrap   = root.querySelector('[data-mrp-wrap]');
    var atcBtn    = root.querySelector('[data-atc]');
    var atcText   = root.querySelector('[data-atc-text]');
    var buyBtn    = root.querySelector('[data-buy]');

    if (!v) {
      if (atcBtn) { atcBtn.disabled = true; }
      if (atcText) atcText.textContent = (config.unavailableLabel || 'Unavailable');
      if (buyBtn) buyBtn.disabled = true;
      return;
    }

    if (priceEl) priceEl.textContent = money(v.price + getTotalAddonsPrice());
    if (compareEl && saveEl) {
      if (v.compare_at_price > v.price) {
        compareEl.textContent = money(v.compare_at_price);
        compareEl.hidden = false;
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        saveEl.textContent = 'Save ' + pct + '%';
        saveEl.hidden = false;
        if (mrpWrap) mrpWrap.hidden = false;
      } else {
        compareEl.hidden = true;
        saveEl.hidden = true;
        if (mrpWrap) mrpWrap.hidden = true;
      }
    }

    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.dataset.variantId = v.id;
    }
    /* Keep GoKwik buy-now form in sync with the selected variant */
    var gkVariantInput = root.querySelector('[data-gokwik-variant]');
    if (gkVariantInput) gkVariantInput.value = v.id;
    if (atcText) {
      atcText.textContent = v.available ? (config.atcLabel || 'Add to Cart') : (config.soldOutLabel || 'Sold Out');
    }
    var moneyC = function (c) { return money(c).replace(/\d{4,}/g, function (n) { return Number(n).toLocaleString('en-US'); }); };
    var atcPrice = root.querySelector('[data-atc-price]');
    if (atcPrice) {
      atcPrice.hidden = !v.available;
      var apNow = atcPrice.querySelector('[data-atc-now]'), apWas = atcPrice.querySelector('[data-atc-was]');
      if (apNow) apNow.textContent = moneyC(v.price);
      if (apWas) { apWas.hidden = !(v.compare_at_price > v.price); apWas.textContent = moneyC(v.compare_at_price || 0); }
    }
    if (buyBtn) buyBtn.disabled = !v.available;

    /* Update URL */
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }

    /* Swap to variant image */
    if (v.image) {
      var idx = product.images.indexOf(v.image);
      if (idx >= 0) {
        if (instant) {
          scrollToIdx(idx, false);  /* jump, no animation, on first paint */
        } else {
          showImg(idx);
        }
      }
    }
  }

  root.querySelectorAll('.kb-pdp__swatch, .kb-pdp__size').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var oi = parseInt(this.dataset.opt, 10);
      selectedOpts[oi] = this.dataset.val;
      updateActiveButtons();
      updatePriceAndATC();
    });
  });
  if (root.classList.contains('kb-pdp--soft')) {
    var kbMoneyPlain = money;
    money = function (cents) {
      return kbMoneyPlain(cents).replace(/\d{4,}/g, function (n) { return Number(n).toLocaleString('en-US'); });
    };
    updatePriceAndATC(true);
  }

  /* ── Low stock alert — real inventory of the selected variant ── */
  var lowStockEl = root.querySelector('[data-low-stock]');
  if (lowStockEl) {
    var updateLowStock = function() {
      var v = findVariant();
      var thr = parseInt(lowStockEl.dataset.threshold, 10) || 5;
      if (v && v.available && v.inv_managed && v.inventory > 0 && v.inventory <= thr) {
        var txt = (lowStockEl.dataset.template || 'Only {count} left').replace('{count}', v.inventory);
        lowStockEl.querySelector('[data-low-stock-text]').textContent = txt;
        lowStockEl.hidden = false;
      } else {
        lowStockEl.hidden = true;
      }
    };
    var __lsOrig = updatePriceAndATC;
    updatePriceAndATC = function(instant) { __lsOrig(instant); updateLowStock(); };
    updateLowStock();
  }

  /* ── Quantity ── */
  var qtyNumEl = root.querySelector('[data-qty-num]');
  root.querySelectorAll('[data-qty]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var delta = parseInt(this.dataset.qty, 10);
      var cur = parseInt(qtyNumEl.textContent, 10) || 1;
      qtyNumEl.textContent = Math.max(1, cur + delta);
    });
  });

  /* ── Personalization field counters + clear-on-type ── */
  root.querySelectorAll('[data-cn-input]').forEach(function(inp) {
    var wrap = inp.closest('.kb-pdp__cn-input-wrap');
    var counter = wrap ? wrap.querySelector('[data-cn-counter]') : null;
    var maxLen = parseInt(inp.dataset.max, 10) || 0;
    inp.addEventListener('input', function() {
      if (counter && maxLen) counter.textContent = inp.value.length + ' / ' + maxLen;
      if (inp.value.trim()) inp.classList.remove('is-error');
    });
  });

  /* ── Add to Cart ── */
  var atc = root.querySelector('[data-atc]');

  /* Unified add-on price — sums all checked [data-addon-input] items */
  function getTotalAddonsPrice() {
    var total = 0;
    root.querySelectorAll('[data-addon-input]:checked').forEach(function(inp) {
      total += parseInt(inp.dataset.giftPrice, 10) || 0;
    });
    return total;
  }

  /* Collect all checked add-on items as cart line items */
  function collectAddons() {
    var items = [];
    root.querySelectorAll('[data-addon-input]:checked').forEach(function(inp) {
      var vid = parseInt(inp.dataset.variantId, 10);
      if (vid) items.push({ id: vid, quantity: 1 });
    });
    return items;
  }

  /* Append every uploaded file to a multipart body under its own property. */
  function appendDesignFiles(fd, designFiles) {
    (designFiles || []).forEach(function(d) {
      if (d && d.file) fd.append('properties[' + (d.propKey || 'Design File') + ']', d.file, d.file.name);
    });
  }

  /* Shared: execute the actual cart/add fetch.
     When designFiles are present the main item is sent as multipart/form-data so
     Shopify uploads it to its CDN and shows a clickable link in the order. */
  function doAddToCart(items, variantId, origText, designFiles, designPropKey) {
    atc.disabled = true;
    atc.innerHTML = (designFiles && designFiles.length)
      ? '<svg aria-hidden="true" focusable="false" class="kb-pdp__spinner spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg><span style="margin-left:8px;font-size:12px;vertical-align:middle;">Image Uploading...</span>'
      : '<svg aria-hidden="true" focusable="false" class="kb-pdp__spinner spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

    var mainItem   = items[0];
    var addonItems = items.slice(1);
    var hasAddons  = addonItems.length > 0;

    function addMain() {
      if (designFiles && designFiles.length) {
        var fd = new FormData();
        fd.append('id', mainItem.id);
        fd.append('quantity', mainItem.quantity || 1);
        if (mainItem.properties) {
          Object.keys(mainItem.properties).forEach(function(k) {
            fd.append('properties[' + k + ']', mainItem.properties[k]);
          });
        }
        appendDesignFiles(fd, designFiles);
        if (!hasAddons) {
          fd.append('sections[]', 'cart-drawer');
          fd.append('sections[]', 'cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
        }
        return fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: fd })
          .then(function(r) { return r.json(); });
      }
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [mainItem],
          sections: hasAddons ? [] : ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      }).then(function(r) { return r.json(); });
    }

    function addAddons() {
      if (!hasAddons) return Promise.resolve(null);
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: addonItems,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      }).then(function(r) { return r.json(); });
    }

    function openDrawer(data) {
      atc.innerHTML = '<span data-atc-text>✓ Added</span>';
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: variantId, sections: data.sections });
        if (typeof publish === 'function') publish('cart-update', { source: 'kb-pdp', cartData: data });
      } else if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }
      setTimeout(function() {
        atc.innerHTML = '<span data-atc-text>' + origText + '</span>';
        atc.disabled = false;
      }, 1800);
    }

    addMain()
      .then(function(data) {
        if (data.status) throw new Error(data.description || 'Error');
        if (!hasAddons) { openDrawer(data); return; }
        return addAddons().then(function(addonData) {
          if (addonData && addonData.status) throw new Error(addonData.description || 'Error');
          openDrawer(addonData);
        });
      })
      .catch(function() {
        atc.innerHTML = '<span data-atc-text>' + origText + '</span>';
        atc.disabled = false;
      });
  }

  /* "Buy without personalisation" toggle — hides the name fields, skips their
     required validation, and tags the line item so fulfilment knows to skip printing. */
  root.querySelectorAll('[data-cn-skip]').forEach(function (cb) {
    var wrap = cb.closest('[data-custom-name]');
    if (!wrap) return;
    cb.addEventListener('change', function () {
      wrap.dataset.skip = cb.checked ? 'true' : 'false';
      if (cb.checked) {
        wrap.querySelectorAll('[data-cn-input]').forEach(function (inp) {
          inp.classList.remove('is-error');
        });
      }
    });
  });

  /* Shared: collect + validate personalization fields */
  function collectPersonalization() {
    var properties = {};
    var requiredMissing = false;
    root.querySelectorAll('[data-cn-input]').forEach(function(inp) {
      /* Skip fields inside a personalisation block the customer opted out of */
      var cnWrap = inp.closest('[data-custom-name]');
      if (cnWrap && cnWrap.dataset.skip === 'true') {
        inp.classList.remove('is-error');
        return;
      }
      var val = inp.value.trim();
      var required = inp.dataset.required === 'true';
      if (required && !val) {
        inp.classList.add('is-error');
        requiredMissing = true;
      } else {
        inp.classList.remove('is-error');
        if (val && inp.dataset.propKey) properties[inp.dataset.propKey] = val;
      }
    });

    /* Record the opt-out on the order line item */
    root.querySelectorAll('[data-custom-name][data-skip="true"]').forEach(function (wrap) {
      var k = wrap.getAttribute('data-skip-prop-key');
      var v = wrap.getAttribute('data-skip-prop-value');
      if (k && v) properties[k] = v;
    });
    if (requiredMissing) {
      var firstErr = root.querySelector('[data-cn-input].is-error');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return null;
    }
    return properties;
  }

  /* Collect design upload — returns { file, propKey } or null (validation fail) or {} (no block) */
  function collectDesignUpload() {
    /* Returns { files: [{file, propKey}, ...] }. A product may now have several
       upload zones (e.g. baby photo + parents photo), each with its own order
       property name from data-du-prop-key. `.file`/`.propKey` are kept pointing
       at the first upload so older single-upload call sites still work. */
    var result = { files: [] };
    var missing = false;
    root.querySelectorAll('[data-design-upload]').forEach(function(wrap) {
      var errorEl = wrap.querySelector('[data-du-error]');
      if (wrap._duFile) {
        result.files.push({ file: wrap._duFile, propKey: wrap.getAttribute('data-du-prop-key') || 'Design File' });
        if (!result.file) {
          result.file = wrap._duFile;
          result.propKey = wrap.getAttribute('data-du-prop-key') || 'Design File';
        }
        if (errorEl) errorEl.style.display = 'none';
        wrap.classList.remove('is-error');
      } else if (wrap.querySelector('[data-du-required]')) {
        if (errorEl) errorEl.style.display = '';
        wrap.classList.add('is-error');
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        missing = true;
      }
    });
    return missing ? null : result;
  }

  /* Design upload block — preview + drag-drop */
  root.querySelectorAll('[data-design-upload]').forEach(function(wrap) {
    var input      = wrap.querySelector('[data-du-input]');
    var zone       = wrap.querySelector('[data-du-zone]');
    var previewEl  = wrap.querySelector('[data-du-preview]');
    var previewImg = wrap.querySelector('[data-du-preview-img]');
    var removeBtn  = wrap.querySelector('[data-du-remove]');
    var filenameEl = wrap.querySelector('[data-du-filename]');
    var labelEl    = wrap.querySelector('[data-du-label]');
    var errorEl    = wrap.querySelector('[data-du-error]');
    var loadingEl  = wrap.querySelector('[data-du-loading]');
    var loadingTxt = wrap.querySelector('[data-du-loading-text]');
    var loadingBar = wrap.querySelector('[data-du-bar]');
    if (!input) return;

    function clearUpload() {
      input.value = '';
      wrap._duFile = null;
      if (previewImg) { previewImg.src = ''; previewImg.style.display = ''; }
      if (previewEl)  previewEl.style.display = 'none';
      if (loadingEl)  loadingEl.style.display = 'none';
      if (labelEl)    labelEl.style.display = '';
      if (filenameEl) filenameEl.textContent = '';
    }

    function handleFile(file) {
      if (!file) return;
      var maxMb = parseInt(wrap.dataset.duMaxMb || '10', 10);
      if (file.size > maxMb * 1024 * 1024) {
        if (errorEl) { errorEl.textContent = 'File too large. Max ' + maxMb + 'MB allowed.'; errorEl.style.display = ''; }
        clearUpload();
        return;
      }
      if (errorEl) errorEl.style.display = 'none';
      wrap.classList.remove('is-error');
      wrap._duFile = file;
      if (filenameEl) filenameEl.textContent = file.name;

      /* Show loading state */
      if (labelEl)    labelEl.style.display = 'none';
      if (previewEl)  previewEl.style.display = 'none';
      if (loadingEl)  loadingEl.style.display = 'flex';
      if (loadingBar) loadingBar.style.width = '0%';
      if (loadingTxt) loadingTxt.textContent = 'Uploading file…';

      function setProgress(pct) {
        if (loadingBar) loadingBar.style.width = pct + '%';
        if (pct >= 100 && loadingTxt) loadingTxt.textContent = 'Done!';
      }

      function showPreview() {
        if (loadingEl) loadingEl.style.display = 'none';
        if (previewEl) previewEl.style.display = 'flex';
      }

      var isPreviewable = file.type.indexOf('image/') === 0 &&
                          file.type.indexOf('heic') < 0 &&
                          file.type.indexOf('heif') < 0;

      if (isPreviewable && previewImg) {
        var reader = new FileReader();
        reader.onprogress = function(e) {
          if (e.lengthComputable) setProgress(Math.round(e.loaded / e.total * 90));
        };
        reader.onload = function(e) {
          setProgress(100);
          previewImg.src = e.target.result;
          previewImg.style.display = '';
          setTimeout(showPreview, 500);
        };
        reader.readAsDataURL(file);
      } else {
        if (previewImg) previewImg.style.display = 'none';
        /* Simulate progress for HEIC / non-previewable */
        var p = 0;
        var iv = setInterval(function() {
          p += 25;
          setProgress(Math.min(p, 90));
          if (p >= 90) clearInterval(iv);
        }, 80);
        setTimeout(function() {
          clearInterval(iv);
          setProgress(100);
          setTimeout(showPreview, 500);
        }, 480);
      }
    }

    input.addEventListener('change', function() {
      if (this.files && this.files[0]) handleFile(this.files[0]);
    });
    if (removeBtn) {
      removeBtn.addEventListener('click', function() { clearUpload(); });
    }
    if (zone) {
      zone.addEventListener('dragover',  function(e) { e.preventDefault(); zone.classList.add('is-drag'); });
      zone.addEventListener('dragleave', function()  { zone.classList.remove('is-drag'); });
      zone.addEventListener('drop', function(e) {
        e.preventDefault();
        zone.classList.remove('is-drag');
        var file = e.dataTransfer && e.dataTransfer.files[0];
        if (file) { try { input.files = e.dataTransfer.files; } catch(ex) {} handleFile(file); }
      });
    }
  });

  /* All add-on cards (gift box + upsells) — highlight + live price */
  root.querySelectorAll('[data-addon-input]').forEach(function(inp) {
    var card = inp.closest('[data-addon-label]');
    function syncCard() { if (card) card.classList.toggle('is-checked', inp.checked); }
    inp.addEventListener('change', function() { syncCard(); updatePriceAndATC(); });
    syncCard();
  });

  /* Frequently Bought Together — dropdown selectors + independent ADD button */
  root.querySelectorAll('[data-upsell-card]').forEach(function(card) {
    var variantsData;
    try { variantsData = JSON.parse(card.dataset.upsellVariants); } catch(e) { return; }

    var selectedOpts = [];
    card.querySelectorAll('[data-upsell-opt]').forEach(function(sel) {
      selectedOpts[parseInt(sel.dataset.upsellOpt, 10)] = sel.value;
    });

    function findUpsellVariant() {
      if (selectedOpts.length === 0) return variantsData[0];
      return variantsData.find(function(v) {
        return v.options.every(function(o, i) { return o === selectedOpts[i]; });
      });
    }

    card.querySelectorAll('[data-upsell-opt]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        selectedOpts[parseInt(this.dataset.upsellOpt, 10)] = this.value;
        var v = findUpsellVariant();
        var addBtn = card.querySelector('[data-upsell-add]');
        if (v) {
          var priceEl = card.querySelector('.kb-pdp__gift-price');
          if (priceEl) priceEl.textContent = '+' + money(v.price);
          if (addBtn) {
            addBtn.disabled = !v.available;
            addBtn.classList.remove('is-added');
            var txt = addBtn.querySelector('[data-upsell-add-text]');
            if (txt) txt.textContent = v.available ? 'ADD' : 'Sold Out';
          }
        }
      });
    });

    var addBtn = card.querySelector('[data-upsell-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        if (addBtn.disabled || addBtn.classList.contains('is-busy')) return;
        var v = findUpsellVariant();
        if (!v || !v.available) return;

        addBtn.classList.add('is-busy');
        addBtn.disabled = true;
        addBtn.innerHTML = '<svg aria-hidden="true" focusable="false" class="kb-pdp__spinner spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: v.id, quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.status) throw new Error(data.description || 'Error');
          addBtn.classList.remove('is-busy');
          addBtn.classList.add('is-added');
          addBtn.disabled = false;
          addBtn.innerHTML = '<span data-upsell-add-text>Added!</span>';
          if (data.sections) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && data.sections['cart-icon-bubble']) {
              bubble.innerHTML = data.sections['cart-icon-bubble'];
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kb-fbt', cartData: data });
            }
          }
        })
        .catch(function() {
          addBtn.classList.remove('is-busy');
          addBtn.disabled = false;
          addBtn.innerHTML = '<span data-upsell-add-text>ADD</span>';
        });
      });
    }
  });

  /* Confirmation modal */
  var cnModal = root.querySelector('[data-cn-modal]');
  var pendingAdd = null;

  function openCnModal(items, variantId, origText, properties, designFiles, designPropKey) {
    if (!cnModal) return false;
    var list = cnModal.querySelector('[data-cn-modal-list]');
    if (list) {
      list.innerHTML = '';
      Object.keys(properties).forEach(function(key) {
        var li = document.createElement('li');
        li.className = 'kb-cn-modal__item';
        li.innerHTML =
          '<span class="kb-cn-modal__key">' + key + '</span>' +
          '<span class="kb-cn-modal__val">' + properties[key] + '</span>';
        list.appendChild(li);
      });
    }
    pendingAdd = { items: items, variantId: variantId, origText: origText, designFiles: designFiles || [], designPropKey: designPropKey || 'Design File' };
    cnModal.style.display = 'flex';
    void cnModal.offsetWidth;
    cnModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    return true;
  }

  function closeCnModal() {
    if (!cnModal) return;
    cnModal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function() { cnModal.style.display = 'none'; }, 260);
  }

  if (cnModal) {
    cnModal.querySelectorAll('[data-cn-modal-close]').forEach(function(el) {
      el.addEventListener('click', closeCnModal);
    });
    var confirmBtn = cnModal.querySelector('[data-cn-modal-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        closeCnModal();
        if (pendingAdd) {
          doAddToCart(pendingAdd.items, pendingAdd.variantId, pendingAdd.origText, pendingAdd.designFiles, pendingAdd.designPropKey);
          pendingAdd = null;
        }
      });
    }
  }

  if (atc) {
    atc.addEventListener('click', function() {
      var v = findVariant();
      if (!v || !v.available) return;

      var properties = collectPersonalization();
      if (properties === null) return;

      var designUpload = collectDesignUpload();
      if (designUpload === null) return;

      var qty = parseInt(qtyNumEl ? qtyNumEl.textContent : '1', 10) || 1;
      var origText = atc.querySelector('[data-atc-text]').textContent;
      var lineItem = { id: v.id, quantity: qty };
      if (Object.keys(properties).length) lineItem.properties = properties;

      var items = [lineItem].concat(collectAddons());
      var designFiles   = designUpload.files   || [];
      var designPropKey = designUpload.propKey || 'Design File';

      if (Object.keys(properties).length && cnModal) {
        openCnModal(items, v.id, origText, properties, designFiles, designPropKey);
      } else {
        doAddToCart(items, v.id, origText, designFiles, designPropKey);
      }
    });
  }

  /* ── Buy Now ── */
  var buy = root.querySelector('[data-buy]');
  if (buy) {
    buy.addEventListener('click', function() {
      var v = findVariant();
      if (!v || !v.available) return;

      var properties = collectPersonalization();
      if (properties === null) return;

      var designUpload = collectDesignUpload();
      if (designUpload === null) return;

      var qty = parseInt(qtyNumEl ? qtyNumEl.textContent : '1', 10) || 1;
      var lineItem = { id: v.id, quantity: qty };
      if (Object.keys(properties).length) lineItem.properties = properties;

      var items = [lineItem].concat(collectAddons());
      var designFiles   = designUpload.files   || [];
      var designPropKey = designUpload.propKey || 'Design File';

      function goCheckout() { window.location.href = '/checkout'; }

      if (designFiles.length || items.length > 1 || Object.keys(properties).length) {
        var mainItem   = items[0];
        var addonItems = items.slice(1);
        var mainReq;
        if (designFiles.length) {
          var fd = new FormData();
          fd.append('id', mainItem.id);
          fd.append('quantity', mainItem.quantity || 1);
          if (mainItem.properties) {
            Object.keys(mainItem.properties).forEach(function(k) {
              fd.append('properties[' + k + ']', mainItem.properties[k]);
            });
          }
          appendDesignFiles(fd, designFiles);
          mainReq = fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: fd });
        } else {
          mainReq = fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [mainItem] })
          });
        }
        mainReq.then(function() {
          if (!addonItems.length) return goCheckout();
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: addonItems })
          }).then(goCheckout);
        });
      } else {
        window.location.href = '/cart/' + v.id + ':' + qty;
      }
    });
  }

  /* ── GoKwik Buy Now: carry size / personalization + quantity into the order ──
     The GoKwik form only submits id + quantity, so JS-collected line-item
     properties (e.g. "Women's Size") were being dropped on GoKwik orders.
     We hook the click in the CAPTURE phase on the form so this runs BEFORE the
     button's inline onBuyNowClick(): validate required fields, then inject the
     values as real properties[...] inputs GoKwik will include. */
  var gkForm = root.querySelector('.kb-pdp__gokwik-form');
  if (gkForm) {
    gkForm.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('#gokwik-buy-now') : null;
      if (!btn) return;

      /* Validate + collect required personalization (size, etc.) */
      var properties = collectPersonalization();
      if (properties === null) {
        /* required field missing — stop GoKwik from proceeding */
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      /* Keep quantity in sync (GoKwik form was hard-coded to 1) */
      var qty = parseInt(qtyNumEl ? qtyNumEl.textContent : '1', 10) || 1;
      var qtyInput = gkForm.querySelector('[data-gokwik-qty]');
      if (qtyInput) qtyInput.value = qty;

      /* Upsert hidden properties[...] inputs so GoKwik includes them */
      gkForm.querySelectorAll('[data-gk-prop]').forEach(function (n) { n.remove(); });
      Object.keys(properties).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        input.value = properties[key];
        input.setAttribute('data-gk-prop', '');
        gkForm.appendChild(input);
      });
    }, true);
  }

  /* ── Accordion (smooth) ── */
  root.querySelectorAll('[data-acc]').forEach(function(acc) {
    var head = acc.querySelector('.kb-pdp__acc-head');
    if (!head) return;
    head.addEventListener('click', function() {
      var open = acc.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ── Sticky mobile ATC ── */
  /* Order on WhatsApp - rebuild the message at click time so it carries the
     size the shopper actually has selected, plus the variant in the link. */
  root.querySelectorAll('[data-kb-wa]').forEach(function (wa) {
    wa.addEventListener('click', function () {
      var phone = wa.getAttribute('data-phone') || '';
      var parts = [wa.getAttribute('data-msg') || '', wa.getAttribute('data-title') || ''];
      var picked = [];
      root.querySelectorAll('.kb-pdp__size.is-active, .kb-pdp__swatch.is-active').forEach(function (el) {
        var v = el.getAttribute('data-val');
        if (v) picked.push(v);
      });
      if (picked.length) parts.push('(' + picked.join(', ') + ')');
      var url = wa.getAttribute('data-url') || window.location.href;
      try {
        var v = findVariant();
        if (v && v.id) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
      } catch (e) {}
      parts.push('- ' + url);
      wa.setAttribute('href', 'https://wa.me/' + phone + '?text=' + encodeURIComponent(parts.join(' ')));

      /* Lead event for Customer events > custom pixel (Meta / GA4). */
      try {
        var sel = findVariant();
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('kb_whatsapp_order_click', {
            product_id: product.id,
            product_title: product.title,
            variant_id: sel ? sel.id : null,
            value: sel ? sel.price / 100 : null,
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
            options: picked.join(', '),
            placement: wa.classList.contains('kb-pdp__sticky-wa') ? 'sticky_bar' : 'product_form'
          });
        }
      } catch (e) {}
    });
  });

  var sticky = root.querySelector('[data-sticky]');
  if (sticky) {
    /* Show the bar while the main buy button is off screen. A page that sells
       on WhatsApp only has no add-to-cart, so watch the WhatsApp button. */
    var mainAtc = root.querySelector('[data-atc]') || root.querySelector('.kb-pdp__wa');
    var stickyAlways = sticky.dataset.stickyAlways === 'true';

    if (stickyAlways) {
      /* Permanent CTA - show immediately and reserve space at the page bottom */
      sticky.classList.add('is-visible');
      sticky.setAttribute('aria-hidden', 'false');
      document.body.classList.add('kb-sticky-atc-on');
    } else if (mainAtc) {
      /* Show the bar only after the main button has scrolled up past the top
         of the screen (not on load while it is still below the fold). A
         position check on scroll, so fast jumps back to the top hide it too. */
      var stickyOn = null, stickyTick = false;
      var checkSticky = function() {
        stickyTick = false;
        var r = mainAtc.getBoundingClientRect();
        /* A hidden main button (no layout) keeps the old behaviour: bar shown. */
        var show = (r.width === 0 && r.height === 0) ? true : r.bottom < 0;
        if (show === stickyOn) return;
        stickyOn = show;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('kb-sticky-atc-on', show);
      };
      var queueSticky = function() { if (!stickyTick) { stickyTick = true; requestAnimationFrame(checkSticky); } };
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      checkSticky();
    }
    var stickyBtn = sticky.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      var stickyOrigHTML = stickyBtn.innerHTML;
      var stickyBusy = false;
      var stickyWarnT = null;
      var stickyNeedsMsg = stickyBtn.getAttribute('data-needs-details') || 'Enter details above';
      function restoreSticky() {
        stickyBtn.innerHTML = stickyOrigHTML;
        stickyBtn.disabled = false;
        stickyBusy = false;
      }
      stickyBtn.addEventListener('click', function() {
        if (stickyBusy || stickyBtn.disabled) return;
        stickyBusy = true;
        stickyBtn.disabled = true;
        stickyBtn.innerHTML = '<svg aria-hidden="true" focusable="false" class="kb-pdp__spinner spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
        var action = sticky.dataset.stickyAction || 'add_to_cart';

        /* Validate before anything else. The collectors flag the offending
           field and scroll to it; without this the sticky button would just
           spin for 3s while the real reason sat off-screen further up. */
        if (collectPersonalization() === null || collectDesignUpload() === null) {
          restoreSticky();
          stickyBtn.innerHTML = stickyNeedsMsg;
          stickyBtn.classList.add('is-warn');
          clearTimeout(stickyWarnT);
          stickyWarnT = setTimeout(function () {
            stickyBtn.innerHTML = stickyOrigHTML;
            stickyBtn.classList.remove('is-warn');
          }, 2600);
          return;
        }

        if (mainAtc && action !== 'buy_now') {
          /* Reuse the in-page button so its validation and drawer behaviour run */
          mainAtc.click();
          setTimeout(function() { if (stickyBusy) restoreSticky(); }, 3000);
          return;
        }

        /* Standalone: the in-page Add to Cart has been removed from this page */
        var v = findVariant();
        if (!v || !v.available) { restoreSticky(); return; }

        var properties = collectPersonalization();
        if (properties === null) { restoreSticky(); return; }

        var designUpload = collectDesignUpload();
        if (designUpload === null) { restoreSticky(); return; }

        var qty = parseInt(qtyNumEl ? qtyNumEl.textContent : '1', 10) || 1;
        var lineItem = { id: v.id, quantity: qty };
        if (Object.keys(properties).length) lineItem.properties = properties;
        var items = [lineItem].concat(collectAddons());

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (action === 'buy_now') { window.location.href = '/checkout'; return; }
            var cd = document.querySelector('cart-drawer');
            if (cd) {
              cd.classList.remove('is-empty');
              if (typeof cd.open === 'function') cd.open();
            }
            restoreSticky();
          })
          .catch(function () { restoreSticky(); });
      });
      /* Restore when cart updates (cart was added + drawer opening) */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
          if (stickyBusy) restoreSticky();
        });
      } else {
        document.addEventListener('cart-updated', function() {
          if (stickyBusy) restoreSticky();
        });
      }
    }

    /* Sticky quantity stepper — sync to main qty so ATC reads correct value */
    var stickyQtyNum = sticky.querySelector('[data-sticky-qty-num]');
    var stickyMinus  = sticky.querySelector('[data-sticky-qty-minus]');
    var stickyPlus   = sticky.querySelector('[data-sticky-qty-plus]');
    function syncStickyToMain() {
      if (qtyNumEl && stickyQtyNum) qtyNumEl.textContent = stickyQtyNum.textContent;
    }
    if (stickyMinus && stickyQtyNum) {
      stickyMinus.addEventListener('click', function() {
        var cur = parseInt(stickyQtyNum.textContent, 10) || 1;
        stickyQtyNum.textContent = Math.max(1, cur - 1);
        syncStickyToMain();
      });
    }
    if (stickyPlus && stickyQtyNum) {
      stickyPlus.addEventListener('click', function() {
        var cur = parseInt(stickyQtyNum.textContent, 10) || 1;
        stickyQtyNum.textContent = cur + 1;
        syncStickyToMain();
      });
    }
    /* keep sticky in sync with main qty when user changes main */
    if (qtyNumEl && stickyQtyNum) {
      var qtyObserver = new MutationObserver(function() {
        if (stickyQtyNum.textContent !== qtyNumEl.textContent) {
          stickyQtyNum.textContent = qtyNumEl.textContent;
        }
      });
      qtyObserver.observe(qtyNumEl, { childList: true, characterData: true, subtree: true });
    }

    /* keep sticky price + compare-at + savings in sync */
    var origUpdate = updatePriceAndATC;
    updatePriceAndATC = function() {
      origUpdate();
      var v = findVariant();
      if (!v) return;
      var sp = sticky.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = money(v.price + getTotalAddonsPrice());
      var scmp = sticky.querySelector('[data-sticky-compare]');
      var ssave = sticky.querySelector('[data-sticky-save]');
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (scmp) {
        if (onSale) { scmp.textContent = money(v.compare_at_price); scmp.removeAttribute('hidden'); }
        else { scmp.setAttribute('hidden', ''); }
      }
      if (ssave) {
        if (onSale) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          ssave.textContent = pct + '% Off';
          ssave.removeAttribute('hidden');
        } else {
          ssave.setAttribute('hidden', '');
        }
      }
      if (stickyBtn) {
        stickyBtn.disabled = !v.available;
        var st = stickyBtn.querySelector('[data-sticky-text]');
        if (st) st.textContent = v.available ? (config.atcLabel || 'Add to Cart') : (config.soldOutLabel || 'Sold Out');
      }
    };
  }

  /* ── Size Guide (supports multiple keyed modals: data-size-guide="men" etc.) ── */
  var sizeGuides = root.querySelectorAll('[data-size-guide]');

  if (sizeGuides.length) {
    root.querySelectorAll('[data-size-guide-open]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-size-guide-open') || '';
        var target = null;
        sizeGuides.forEach(function(g) {
          if ((g.getAttribute('data-size-guide') || '') === key) target = g;
        });
        if (!target) target = sizeGuides[0];
        target.style.display = 'flex';
        void target.offsetWidth;  /* force reflow so opacity transitions */
        target.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });

    sizeGuides.forEach(function(g) {
      g.querySelectorAll('[data-size-guide-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          g.classList.remove('is-open');
          document.body.style.overflow = '';
          setTimeout(function() { g.style.display = 'none'; }, 300);
        });
      });
    });
  }

  /* Initial state — instant (no scroll/transition animation on first paint) */
  updateActiveButtons();
  updatePriceAndATC(true);
}

document.querySelectorAll('[data-kb-pdp]').forEach(initPDP);

/* Verified badge beside the Loox rating widget (near the title).
   The widget itself is app-rendered, so we append a sibling badge. */
(function () {
  var info = document.querySelector('.kb-pdp__info');
  if (!info) return;
  var BADGE =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill="#1877F2" d="M12 1.3l2.4 1.9 3-.5 1.1 2.9 2.9 1.1-.5 3 1.9 2.4-1.9 2.4.5 3-2.9 1.1-1.1 2.9-3-.5-2.4 1.9-2.4-1.9-3 .5-1.1-2.9-2.9-1.1.5-3L.7 12l1.9-2.4-.5-3L5 5.5l1.1-2.9 3 .5z"/><path d="m8.4 12.3 2.4 2.4 4.8-5" stroke="#fff" stroke-width="2.1" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    'Verified Reviews';
  function addBadge() {
    var w = info.querySelector('.loox-rating');
    if (!w || w.dataset.kbVerified) return !!w;
    w.dataset.kbVerified = '1';
    if (!(parseInt(w.dataset.raters, 10) > 0)) {
      var kbEmptyBlock = w.closest('.shopify-app-block');
      if (kbEmptyBlock) kbEmptyBlock.style.display = 'none';
      return true;
    }
    var b = document.createElement('span');
    b.className = 'kb-rating__verified kb-rating__verified--inline';
    b.innerHTML = BADGE;
    w.insertAdjacentElement('afterend', b);
    return true;
  }
  if (!addBadge()) {
    var mo = new MutationObserver(function () { if (addBadge()) mo.disconnect(); });
    mo.observe(info, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
})();
